import script from "./_tickets-filter.vue?vue&type=script&setup=true&lang=ts"
export * from "./_tickets-filter.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__